import type { SupportReadingTask } from '@dynamika-shared/types/subjects';

export const getReadingCodeText = (
  readingTask: Pick<
    SupportReadingTask,
    'parentReadingCode' | 'readingCode'
  >
): string => {
  if (!readingTask.readingCode) {
    return '';
  }

  if (readingTask.parentReadingCode) {
    return `${readingTask.parentReadingCode}/${readingTask.readingCode}`;
  }

  return readingTask.readingCode;
};
